import { LoadingSkeleton } from '@joor/design-system'
import styled from 'styled-components/macro'

export function Loading() {
  return (
    <LoadingContainer data-testid={ProductsLoadingTestIds.ProductsLoading}>
      <SummaryLoading />
      <div className="divider" />
      <ProductsListLoading />
    </LoadingContainer>
  )
}

export const ProductsLoadingTestIds = {
  ProductsLoading: 'products-loading',
} as const

const LoadingContainer = styled.div`
  .summary-loading {
    display: flex;
    align-items: center;
    padding: 16px 10px 10px;
    gap: 12px;

    .item {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 56px;
      padding: 10px;
      border: 1px solid var(--color-primary-200);
      border-radius: 5px;
      line-height: 1;
    }
  }
  .divider {
    border-bottom: 1px solid var(--color-primary-100);
  }
  .product-list {
    & div:last-child {
      border-bottom: none;
    }

    .product-item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;
      padding: 16px 10px 10px;
      border-bottom: 1px solid var(--color-primary-100);

      .image {
        width: 60px;
        height: 95px;
      }

      .right {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }
`

function SummaryLoading() {
  return (
    <div className="summary-loading">
      <AmountItemLoading />
      <AmountItemLoading />
      <AmountItemLoading />
    </div>
  )
}

function AmountItemLoading() {
  return (
    <div className="item">
      <LoadingSkeleton height={10} />
      <LoadingSkeleton height={10} />
    </div>
  )
}

function ProductsListLoading() {
  const amount = 5
  return (
    <div className="product-list">
      {Array.apply(null, Array(amount)).map((_, index) => (
        <ProductItemLoading key={index} />
      ))}
    </div>
  )
}

function ProductItemLoading() {
  return (
    <div className="product-item">
      <LoadingSkeleton width={60} height={95} className="image" />
      <div className="right">
        <LoadingSkeleton width={154} height={10} />
        <div>
          <LoadingSkeleton height={10} />
          <LoadingSkeleton height={10} />
        </div>
      </div>
    </div>
  )
}
